class Tour {
    constructor() {
        this.wt = null;
        this.init();
    }


    init() {
        let thisClass = this;
        const steps = [
            {
                title: "Start Your GoodAccess Tour",
                width: '700px',
                height: '700px',
                content: this.buildContent({
                    content: "<p>GoodAccess is an all-in-one Zero Trust Network Access solution that provides enterprise-grade security that is easy to deploy and manage, helping you comply with regulations and allowing your business to scale.</p> <p>It creates a software-defined perimeter –  an invisible, private, and secure part of the internet for your team. GoodAccess adapts to your existing infrastructure while providing cutting-edge protection against modern cyber threats.</p> <p>This ensures your network remains flexible, secure, and ready for future challenges.</p>",
                    class: 'start-tour'
                }),
                breakpoints: {
                    width: {
                        1100: {scroll: false},
                        720: {width: '80%'},
                        480: {width: '100%'}
                    }
                },
                onNext: () => {KTUtil.scrollTop(0,0), thisClass.delayBookDemo(); thisClass.initClosing();}
            },
            {
                element: '[data-tour="step1"]',
                title: 'Your Secure Network Ecosystem',
                content: this.buildContent({
                    highlight: {
                        src: "https://goodaccess-storage.b-cdn.net/walktrough/dashboard/ecosystem.png",
                        width: 767
                    },
                    content: "<p>Create a united protected environment accessible only by your team and invisible to the public internet.</p> <p>Integrate all your resources — users, systems, infrastructure — and manage them all centrally.</p> <p> Cloud services, on-prem systems, employees, or contractors, all are secured under one umbrella.</p>"
                }),
                onNext: () => {KTUtil.scrollTop(0,0); thisClass.delayBookDemo(); thisClass.initClosing();},
                breakpoints: {
                    width: {
                        1300: {scroll: true},
                        1250: {placement: 'bottom'},
                        768: {element: false, placement: false, width: '100%'},
                    }
                }
            },
            {
                element: '[data-tour="step2"]',
                title: 'Dedicated Gateways',
                placement: 'right-start',
                content: this.buildContent({
                    highlight: {
                        src: "https://goodaccess-storage.b-cdn.net/walktrough/dashboard/gateways.png",
                        width: 767
                    },
                    content: "<p>GoodAccess offers a global network of secure gateways across 35+ locations. These gateways act as proxies between your team members and your internal systems, providing secure connectivity from anywhere. Each gateway comes with a dedicated static IP address, making it easy to whitelist access to your cloud services.</p> <p>Deploy as many gateways as needed for optimal performance and redundancy. This ensures low-latency connections for your global workforce while maintaining robust security protocols.</p> "
                }),
                onNext: () => {KTUtil.scrollTop(0,0); thisClass.initClosing();},
                breakpoints: {
                    width: {
                        1300: {scroll: true, placement: 'right-start'},
                        1250: {placement: 'bottom'},
                        768: {element: false, placement: false, width: '100%'},
                    }
                }
            },
            {
                element: '[data-tour="step3"]',
                title: 'Identity and Access Management',
                placement: 'left-start',
                content: this.buildContent({
                    // image: {
                    //     src: "https://pendo-eu-static-6745992914141184.storage.googleapis.com/nvxGn9sPySMm1JJWqsyYdFHCcdc/guide-media-abb5ae56-249e-4dfb-a398-5e8207a7d555",
                    //     width: 400,
                    //     height: 130
                    // },
                    highlight: {
                        src: "https://goodaccess-storage.b-cdn.net/walktrough/dashboard/members.png",
                        width: 767
                    },
                    content: "<p>Centralize user identities and access rights. Use SSO and SCIM for seamless provisioning. Organize members into groups and set granular access rules. Add or remove users instantly, simplifying identity control across your entire network.</p><p>Define precisely who can access what, when, and from where, implementing true least-privilege access. This level of control ensures you can maintain strict security standards while providing the access your team needs to be productive.</p>"
                }),
                breakpoints: {
                    width: {
                        1300: {placement: 'bottom'},
                        768: {menu:false, element: false, placement: false, width: '100%'},
                    }
                },
                onNext: () => {
                    thisClass.initClosing();
                }
            },
            {
                element: '[data-tour="step4"]',
                title: 'Systems and Infrastructure',
                placement: 'left-start',
                content: this.buildContent({
                    // image: {
                    //     src: "https://pendo-eu-static-6745992914141184.storage.googleapis.com/nvxGn9sPySMm1JJWqsyYdFHCcdc/guide-media-1e58421a-ca1c-402a-ade8-e5355e44fbb2",
                    //     width: 500,
                    //     height: 200
                    // },
                    highlight: {
                        src: "https://goodaccess-storage.b-cdn.net/walktrough/dashboard/systems.png",
                        width: 767
                    },
                    content: "<p>Protect all your assets with ease. GoodAccess ensures your on-prem systems, cloud services, and applications are accessible only to authorized users, which is ideal for securing both modern cloud infrastructures and legacy systems.</p> <p>Maintain consistent security across your entire IT ecosystem, regardless of where your resources are hosted. Whether you’re managing a hybrid environment or transitioning to the cloud, GoodAccess adapts to your needs.</p>"
                }),
                onNext: () => {KTUtil.scrollTop(0,0), this.delayBookDemo(); thisClass.initClosing();},
                breakpoints: {
                    width: {
                        1200: {placement: 'bottom'},
                        768: {element: false, placement: false, width: '100%'},
                    }
                }
            },
            {
                element: '[data-tour="step5"]',
                title: 'Device Security and Threat Protection',
                placement: 'right-start',
                content: this.buildContent({
                    highlight: {
                        src: "https://goodaccess-storage.b-cdn.net/walktrough/dashboard/device-security.png",
                        width: 768
                    },
                    content: "<p>Confidently support remote work and BYOD policies without sacrificing security.</p> <p>Device Posture Check ensures only compliant devices can access your network and reduces the risk of compromised endpoints, while Threat Blocker actively detects and blocks threats in real-time.</p> <p>These features create a robust defense against both external threats and potential internal vulnerabilities.</p>"
                }),
                breakpoints: {
                    width: {
                        1100: {placement: 'bottom', switchOverlay: true},
                        991: {menu: true, switchOverlay: true},
                        768: {menu:false, element: false, placement: false, width: '100%'},
                    },
                    height: {
                        720: {
                            width: 1300,
                            changes: {
                                switchOverlay: true
                            }
                        }
                    }
                },
                onNext: () => {thisClass.initClosing();}
            },
            {
                element: '[data-tour="step6"]',
                title: 'Access Control (Cloud Firewall)',
                placement: 'right-start',
                content: this.buildContent({
                    highlight: {
                        src: "https://goodaccess-storage.b-cdn.net/walktrough/dashboard/access-control.png",
                        width: 768
                    },
                    content: "<p>Implement granular access policies with GoodAccess's powerful Access Control features. Define precise rules for who can access which resources, and from where.</p> <p>This allows you to enforce the principle of least privilege across your entire network, enhancing security while maintaining productivity. Easily manage and adjust access rights as your organization's needs evolve.</p>"
                }),
                breakpoints: {
                    width: {
                        800: {placement: 'right-start', width: '70%'},
                        768: {menu:false, element: false, placement: false, width: '100%'},
                    }
                },
                onNext: () => {thisClass.initClosing();}
            },
            {
                element: '[data-tour="step7"]',
                title: 'Comprehensive Logging and Reporting',
                content: this.buildContent({
                    highlight: {
                        src: "https://goodaccess-storage.b-cdn.net/walktrough/dashboard/security-logs.png",
                        width: 767
                    },
                    content: "<p>Generate detailed logs and reports for compliance audits and data-driven security decisions.</p> <p>Monitor network usage, user activity, and security events in real-time. Detect anomalies to identify potential threats. Automatic weekly reports provide regular insights into your network's security status.</p> <p>Leverage our API to set up automated zero-day responses, such as blocking users/devices or isolating systems based on detected security events. This powerful feature enables rapid reaction to potential threats, further enhancing your security posture.</p>",
                }),
                placement: 'right-start',
                width: '600px',
                breakpoints: {
                    width: {
                        992: {menu: true},
                        800: {width: '500px', menu: true},
                        768: {menu:false, element: false, placement: false, width: '100%'},
                    }
                }
            },
            {
                title: 'Sharpen Your Setup With a Personalized Demo',
                content: this.buildContent({
                    highlightDemo: true,
                    image: {
                        src: "https://pendo-eu-static-6745992914141184.storage.googleapis.com/nvxGn9sPySMm1JJWqsyYdFHCcdc/guide-media-846d169c-7fd7-418e-9268-f9a824df58e1",
                        width: 600,
                        height: 180
                    },
                    class: 'no-full-screen',
                    content: "Let our solution architects tailor GoodAccess perfectly to your needs. Achieve best security practices, unlock the full potential of GoodAccess for your team, and save time. Our team will guide you through a personalized and seamless integration into your existing infrastructure!"
                }),
                onNext: () => {
                    KTUtil.scrollTop(0,0);
                    thisClass.initClosing();
                },
                width: '700px',
                breakpoints: {
                    width: {
                        768: {switchOverlay: true, scroll: true},
                        720: {width: '100%', switchOverlay: true, scroll: true},
                        480: {width: '100%', scroll: false}
                    }
                }
            },
            {
                element: '[data-tour="step8"]',
                title: 'Walkthrough Completed!',
                placement: 'left-end',
                content: this.buildContent({
                    highlight: {
                        src: "https://goodaccess-storage.b-cdn.net/walktrough/dashboard/walkthrough.png",
                        width: 480
                    },
                    class: 'no-full-screen',
                    content: "Want a refresher? You can always find the Product Walkthrough in the Help & Feedback section."
                }),
                breakpoints: {
                    width: {
                        700: {width: '80%'},
                        480: {menu: false, element: false, placement: false, width: '100%'},
                    }
                },
                onNext: () => {thisClass.initClosing();}
            }];

        this.wt = new WebTour({
            width: '600px',
            height: '800px',
            removeArrow: true,
            keyboard: false,
            allowClose: true
        });
        this.wt.setSteps(this.buildSteps(steps));

        // disable scroll until tour ends
        $('#productTour').on('click', () => {
            setTimeout(() => {
                if (document.body.clientWidth < 1200) {
                    let current;
                    if(current = document.querySelector('.wt-mobile-overlay')) {
                        current.remove();
                    }
                    let elem = document.createElement('div');
                    elem.classList.add('wt-mobile-overlay');
                    elem.classList.add('shown');
                    document.body.appendChild(elem);
                }
            }, 0);
            thisClass.wt.start();
            KTUtil.scrollTop();
            thisClass.initClosing();
        });
    }

    initClosing() {
        let thisClass = this;
        // close button
        setTimeout(() => {
            $('.close-tour').on('click', () => {
                thisClass.wt.stop();
            });
        },0);
    }
    buildContent(data) {
        let img = "";
        let highlight = "";
        let video = "";
        let content = "";
        let btnHTML = '';
        let closeHTML = '';
        let classes = data.class ??= '';
        if(data.highlight && (document.body.clientWidth < data.highlight.width)) {
            (new Image()).src = data.highlight.src;
            highlight = "<div><img src='"+data.highlight.src+"' class='highlight-img' /></div>";
        }
        if(data.image && (!data.highlight || data.highlight.width <= document.body.clientWidth)) {
            (new Image()).src = data.image.src;
            img = "<div class='d-flex justify-content-center'> <img src='"+ data.image.src +"' width='"+data.image.width+"'  /> </div>";
        }
        if(data.video && (!data.highlight || data.highlight.width < document.body.clientWidth)) {
            video = "<div class='d-flex justify-content-center'> <iframe id=\"player\"\n" +
                "  src='"+data.video.src+"' \n "+
                "  frameborder=\"0\" width='"+data.video.width+"' height='"+data.video.height+"' ></iframe> </div>";
        }
        if(data.content) {
            content = "<div class='pt-6'><p> "+ data.content +" </p></div>";
        }

        if(!data.demoButton) {
            btnHTML = '<a href="https://calendar.goodaccess.com/meetings/eva-hisemova" id="bookDemo" class="btn btn-sm '+(data.highlightDemo ? 'btn-danger' : 'btn-light-primary')+' btn-flex" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">\n' +
                ' Book a live demo \n' +
                ' </a>';
        }

        if(!data.close) {
            closeHTML = '<div class="btn btn-icon btn-sm btn-active-icon-primary close-tour">' +
                '<span class="svg-icon svg-icon-1">\n' +
                '                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>\n' +
                '                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>\n' +
                '                            </svg>\n' +
                '                        </span>' +
                '</div>';
        }

        return "<div class='tour-content-wrapper "+classes+"'>".concat(highlight).concat(img).concat(video).concat(content).concat(btnHTML).concat("</div>").concat(closeHTML);
    }

    toggleMenu() {
        $("#kt_app_sidebar_mobile_toggle").click();
    }

    switchOverlay() {
        $(".wt-mobile-overlay").toggleClass("shown");
    }

    buildSteps(steps) {
        let thisClass = this;
        let returnArr = [];
        steps.forEach(step => {
            // Default step
            let stepObject = {...step};
            // Breakpoints
            if(!("breakpoints" in step)) {
                returnArr.push(stepObject);
                return;
            }
            if("width" in step.breakpoints) {
                Object.keys(step.breakpoints.width).sort((a,b) => {return b-a}).forEach(key => {
                    if(document.body.clientWidth < key) {
                        // placement
                        if("placement" in step.breakpoints.width[key]) {
                            if(step.breakpoints.width[key].placement) {
                                stepObject.placement = step.breakpoints.width[key].placement;
                            } else {
                                delete stepObject.placement;
                            }
                        }
                        // width
                        if("width" in step.breakpoints.width[key]) {
                            stepObject.width = step.breakpoints.width[key].width;
                        }

                        // element
                        if("element" in step.breakpoints.width[key]) {
                            delete stepObject.element;
                        }

                        stepObject.onNext = function() {
                            thisClass.initClosing();
                            thisClass.delayBookDemo();
                            if("switchOverlay" in this.breakpoints.width[key]) {
                                thisClass.switchOverlay();
                            }
                            if("menu" in this.breakpoints.width[key] && this.breakpoints.width[key].menu) {
                                thisClass.toggleMenu();
                            }
                            if("scroll" in this.breakpoints.width[key] && step.breakpoints.width[key].scroll) {
                                KTUtil.scrollTop(0,0);
                            }
                        };
                    }
                });
            }
            returnArr.push(stepObject);
        });
        return returnArr;
    }

    delayBookDemo() {
        setTimeout(() => {
            $('#bookDemo').toggleClass('no-pointer-events');
        },0);
        setTimeout(() => {
            $('#bookDemo').toggleClass('no-pointer-events');
        },100);
    }
}

window.Tour = Tour;